// src/Components/Pills/SinglePillNoCircle.js
import React from 'react';
import './SinglePillNoCircle.css';

function SinglePillNoCircle({ title, value, Icon, iconColor = '#007bff', subLabel }) {
  return (
    <div className="pill-card-no-circle shadow-sm">
      <div className="pill-content-wrapper">
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <p className="pill-title" style={{ marginRight: 0 }}>{title}</p>
          <Icon style={{ color: iconColor, fontSize: '1.1rem', marginLeft: 0 }} />
        </div>
        <p className="pill-value" style={{ textAlign: 'left' }}>{value}</p>
      </div>
      {subLabel && (
        <div className="pill-sublabel-wrapper">
          <span className="pill-sublabel">{subLabel}</span>
        </div>
      )}
    </div>
  );
}

export default SinglePillNoCircle;
